import React from 'react';

import { Tag } from 'antd';
import { T } from 'react-translator-component';

const RISK_CONFIG = {
  HIGH: { color: 'red', label: 'High risk' },
  MEDIUM: { color: 'orange', label: 'Medium risk' },
  LOW: { color: 'green', label: 'Low risk' },
};

const RiskScoreBadge = ({ loading, data, label, emptyText = 'No score' }) => {
  const prefix = label ? <>{T(label)}: </> : null;

  if (loading) {
    return (
      <Tag>
        {prefix}
        {T('Loading score')}…
      </Tag>
    );
  }

  if (!data || data.score == null || !RISK_CONFIG[data.riskLevel]) {
    return (
      <Tag>
        {prefix}
        {T(emptyText)}
      </Tag>
    );
  }

  const { color, label: riskLabel } = RISK_CONFIG[data.riskLevel];

  return (
    <Tag color={color}>
      {prefix}
      {Math.round(data.score)} · {T(riskLabel)}
    </Tag>
  );
};

export default RiskScoreBadge;
